import { createContext, useContext } from "react";

import { Dayjs } from "dayjs";

const WeekContext = createContext<Dayjs | null>(null);
export const useWeekValue = () => useContext(WeekContext);

export default WeekContext;
